import React, { useEffect, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
const durationSeconds = 7 * 60 * 60 + 43 * 60 + 21;
export function Countdown() {
  const [seconds, setSeconds] = useState(durationSeconds);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => value > 0 ? value - 1 : durationSeconds), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const minutes = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0');
  const remainingSeconds = (seconds % 60).toString().padStart(2, '0');
  return <div className="rounded-xl border border-[#e5c5a0] bg-[#fff5e5] px-4 py-3 text-center" data-id="element-15">
      <div className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-[#8b4a33]" data-id="element-16">
        <Clock3Icon className="h-4 w-4" aria-hidden="true" data-id="element-17" />
        Esta oferta finaliza en
      </div>
      <p className="mt-1 font-mono text-2xl font-bold tracking-[0.14em] text-[#263a2a]" aria-live="polite" data-id="element-18">
        {hours}:{minutes}:{remainingSeconds}
      </p>
    </div>;
}